import axios, { AxiosError } from 'axios';
import store from 'store';

import { useQuery } from '@tanstack/react-query';

const getProposalHistory: {
  (id: number): Promise<any>;
} = async (id: number) => {
  const header = {
    Authorization: `Token ${store.getState().user.token}`,
  };

  const res = await axios({
    baseURL:
      process.env.REACT_APP_ADSERVER_ENDPOINT + `/proposal/${id}/history`,
    method: 'GET',
    headers: header,
  });
  return res.data;
};

export const useGetProposalHistory = (
  id: number,
): {
  data: any;
  status: string;
  isLoading: boolean;
} => {
  const { data, status, isLoading } = useQuery<any, AxiosError>({
    queryKey: ['proposalHistory', id],
    queryFn: () => getProposalHistory(id),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    data,
    status,
    isLoading,
  };
};
